// Risk, copy, alerts, strategies, indicators (SPEC §7.3, §10, §11, §11A, §12.10, §16).

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/risk.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { NoticeLevel, RiskStatus } from "./common_pb";
import { file_helm_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file helm/v1/risk.proto.
 */
export const file_helm_v1_risk: GenFile = /*@__PURE__*/
  fileDesc("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", [file_helm_v1_common]);

/**
 * Pushed on every change and at <=4 Hz while positions are open (SPEC §7.3). One account's
 * risk engine `Evaluation` (crates/domain/src/risk/engine.rs); an ordered, replayable event.
 * Optional fields are absent when the limit is not configured (never "0 = unset").
 *
 * @generated from message helm.v1.RiskState
 */
export type RiskState = Message<"helm.v1.RiskState"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * meaningful only when balance_known
   *
   * @generated from field: sint64 balance_cents = 2;
   */
  balanceCents: bigint;

  /**
   * @generated from field: sint64 realized_today_cents = 3;
   */
  realizedTodayCents: bigint;

  /**
   * meaningful only when unrealized_tracked
   *
   * @generated from field: sint64 unrealized_cents = 4;
   */
  unrealizedCents: bigint;

  /**
   * @generated from field: sint64 fees_today_cents = 5;
   */
  feesTodayCents: bigint;

  /**
   * @generated from field: sint64 equity_cents = 6;
   */
  equityCents: bigint;

  /**
   * meaningful only when drawdown_tracked
   *
   * @generated from field: sint64 dd_threshold_cents = 7;
   */
  ddThresholdCents: bigint;

  /**
   * equity - threshold; meaningful only when drawdown_tracked
   *
   * @generated from field: sint64 room_cents = 8;
   */
  roomCents: bigint;

  /**
   * @generated from field: sint64 room_ticks_at_position = 9;
   */
  roomTicksAtPosition: bigint;

  /**
   * firm daily loss limit
   *
   * @generated from field: optional sint64 daily_loss_room_cents = 10;
   */
  dailyLossRoomCents?: bigint | undefined;

  /**
   * @generated from field: helm.v1.RiskStatus status = 11;
   */
  status: RiskStatus;

  /**
   * @generated from field: string firm_profile_id = 12;
   */
  firmProfileId: string;

  /**
   * @generated from field: uint32 profile_version = 13;
   */
  profileVersion: number;

  /**
   * @generated from field: optional sint64 pdll_room_cents = 14;
   */
  pdllRoomCents?: bigint | undefined;

  /**
   * @generated from field: optional sint64 pdpt_room_cents = 15;
   */
  pdptRoomCents?: bigint | undefined;

  /**
   * 0 when no lockout is active
   *
   * @generated from field: fixed64 lockout_until_ms = 16;
   */
  lockoutUntilMs: bigint;

  /**
   * "drawdown" | "daily_loss" | "pdll" | "daily_trail" | "" (none)
   *
   * @generated from field: string binding_constraint = 17;
   */
  bindingConstraint: string;

  /**
   * PnL plant down: tick-level P&L only (SPEC §6.12)
   *
   * @generated from field: bool degraded = 18;
   */
  degraded: boolean;

  /**
   * what PDLL / PDPT / the daily trail are measured on
   *
   * @generated from field: sint64 day_pnl_cents = 19;
   */
  dayPnlCents: bigint;

  /**
   * drawdown peak (intraday peak equity / EOD peak balance)
   *
   * @generated from field: sint64 peak_cents = 20;
   */
  peakCents: bigint;

  /**
   * daily trailing floor, once armed
   *
   * @generated from field: optional sint64 trail_level_cents = 21;
   */
  trailLevelCents?: bigint | undefined;

  /**
   * @generated from field: optional sint64 trail_room_cents = 22;
   */
  trailRoomCents?: bigint | undefined;

  /**
   * best day P&L at which the trail arms
   *
   * @generated from field: optional sint64 trail_arm_at_cents = 23;
   */
  trailArmAtCents?: bigint | undefined;

  /**
   * room to binding_constraint
   *
   * @generated from field: optional sint64 binding_room_cents = 24;
   */
  bindingRoomCents?: bigint | undefined;

  /**
   * new INCREASING orders are refused (lockout, block, lock, invalid config)
   *
   * @generated from field: bool blocks_new_orders = 25;
   */
  blocksNewOrders: boolean;

  /**
   * CME trading day of these figures, "YYYY-MM-DD"
   *
   * @generated from field: string trading_day = 26;
   */
  tradingDay: string;

  /**
   * a drawdown profile applies to this account
   *
   * @generated from field: bool drawdown_tracked = 27;
   */
  drawdownTracked: boolean;

  /**
   * balance_cents comes from a configured start balance / PnL plant
   *
   * @generated from field: bool balance_known = 28;
   */
  balanceKnown: boolean;

  /**
   * false: the gateway has no marks yet; clients use their own
   *
   * @generated from field: bool unrealized_tracked = 29;
   */
  unrealizedTracked: boolean;

  /**
   * non-empty: the stored risk settings are invalid (RISK_CONFIG_INVALID)
   *
   * @generated from field: string config_error = 30;
   */
  configError: string;

  /**
   * Contract limits (owner 2026-09-28, ADR-0033): HELM has no fixed cap of its own. Absent = not set.
   *
   * the user's optional per-account max order quantity (enforced by HELM)
   *
   * @generated from field: optional uint32 max_order_qty = 31;
   */
  maxOrderQty?: number | undefined;

  /**
   * the user's optional per-account max |position| (enforced by HELM)
   *
   * @generated from field: optional uint32 max_position = 32;
   */
  maxPosition?: number | undefined;

  /**
   * Rithmic RMS (ResponseAccountRmsInfo), shown only: Rithmic enforces it
   *
   * @generated from field: optional uint32 rms_max_order_qty = 33;
   */
  rmsMaxOrderQty?: number | undefined;

  /**
   * Rithmic RMS max long position, shown only
   *
   * @generated from field: optional uint32 rms_buy_limit = 34;
   */
  rmsBuyLimit?: number | undefined;

  /**
   * Rithmic RMS max short position, shown only
   *
   * @generated from field: optional uint32 rms_sell_limit = 35;
   */
  rmsSellLimit?: number | undefined;

  /**
   * Prop-account targets and limits (owner 2026-09-29, ADR-0034), display and warnings only:
   * from the user's per-account override, else Rithmic RMS, else the detected firm profile.
   * Money is marked to market (equity_cents); absent = not configured / not known.
   *
   * the profile's (or overridden) start balance
   *
   * @generated from field: optional sint64 start_balance_cents = 36;
   */
  startBalanceCents?: bigint | undefined;

  /**
   * profit needed over the start balance
   *
   * @generated from field: optional sint64 profit_target_cents = 37;
   */
  profitTargetCents?: bigint | undefined;

  /**
   * start + target − equity
   *
   * @generated from field: optional sint64 profit_target_room_cents = 38;
   */
  profitTargetRoomCents?: bigint | undefined;

  /**
   * firm daily loss limit (amount)
   *
   * @generated from field: optional sint64 daily_loss_limit_cents = 39;
   */
  dailyLossLimitCents?: bigint | undefined;

  /**
   * max / trailing drawdown amount
   *
   * @generated from field: optional sint64 drawdown_amount_cents = 40;
   */
  drawdownAmountCents?: bigint | undefined;

  /**
   * equity at which the account is liquidated
   *
   * @generated from field: optional sint64 auto_liq_level_cents = 41;
   */
  autoLiqLevelCents?: bigint | undefined;

  /**
   * equity − auto_liq_level (drawdown tracked only)
   *
   * @generated from field: optional sint64 auto_liq_room_cents = 42;
   */
  autoLiqRoomCents?: bigint | undefined;

  /**
   * "override" | "profile" | ""
   *
   * @generated from field: string profit_target_source = 43;
   */
  profitTargetSource: string;

  /**
   * "override" | "rms" | "profile" | "operator" | ""
   *
   * @generated from field: string daily_loss_source = 44;
   */
  dailyLossSource: string;

  /**
   * "override" | "profile" | "operator" | ""
   *
   * @generated from field: string drawdown_source = 45;
   */
  drawdownSource: string;

  /**
   * "rms" | "override" | "profile" | "operator" | ""
   *
   * @generated from field: string auto_liq_source = 46;
   */
  autoLiqSource: string;

  /**
   * "Apex Trader Funding · 300K Evaluation"
   *
   * @generated from field: string profile_label = 47;
   */
  profileLabel: string;

  /**
   * false → amber "unverified" badge
   *
   * @generated from field: bool profile_verified = 48;
   */
  profileVerified: boolean;

  /**
   * @generated from field: string profile_source_url = 49;
   */
  profileSourceUrl: string;

  /**
   * "YYYY-MM-DD" or ""
   *
   * @generated from field: string profile_last_verified = 50;
   */
  profileLastVerified: string;

  /**
   * how the profile was chosen (detected from …)
   *
   * @generated from field: string profile_basis = 51;
   */
  profileBasis: string;

  /**
   * several plans fit: the user picks one
   *
   * @generated from field: repeated string profile_candidates = 52;
   */
  profileCandidates: string[];

  /**
   * OB4 / SPEC §9.8: the user's per-account "confirm orders above N contracts" (Risk Settings).
   * Client-side only: a larger order always asks for confirmation, even with one-click on. Absent =
   * over 50 % of the max order quantity when one is known, else the client default (2).
   *
   * @generated from field: optional uint32 confirm_qty_above = 53;
   */
  confirmQtyAbove?: number | undefined;
};

/**
 * Describes the message helm.v1.RiskState.
 * Use `create(RiskStateSchema)` to create a new message.
 */
export const RiskStateSchema: GenMessage<RiskState> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 0);

/**
 * @generated from message helm.v1.RiskEvent
 */
export type RiskEvent = Message<"helm.v1.RiskEvent"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * WARN | DANGER | PDLL_HIT | PDPT_HIT | LOCKOUT_START | LOCKOUT_END | GUARD_FLATTEN | FIRM_BREACH_DETECTED
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string detail_json = 4;
   */
  detailJson: string;
};

/**
 * Describes the message helm.v1.RiskEvent.
 * Use `create(RiskEventSchema)` to create a new message.
 */
export const RiskEventSchema: GenMessage<RiskEvent> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 1);

/**
 * @generated from message helm.v1.CopyFollowerState
 */
export type CopyFollowerState = Message<"helm.v1.CopyFollowerState"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * ACTIVE | PAUSED | DESYNC | DISCONNECTED | SKIPPED
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: string state_reason = 3;
   */
  stateReason: string;

  /**
   * @generated from field: sint32 expected_qty = 4;
   */
  expectedQty: number;

  /**
   * @generated from field: sint32 actual_qty = 5;
   */
  actualQty: number;

  /**
   * @generated from field: sint64 today_pnl_cents = 6;
   */
  todayPnlCents: bigint;

  /**
   * @generated from field: uint32 last_copy_latency_ms = 7;
   */
  lastCopyLatencyMs: number;

  /**
   * @generated from field: string last_error = 8;
   */
  lastError: string;

  /**
   * Copy trader (SPEC §11, A5, ADR-0037): the follower's login and switches as the gateway sees them.
   *
   * stored login of the follower account (empty: the env dev login)
   *
   * @generated from field: string login_id = 9;
   */
  loginId: string;

  /**
   * the per-follower switch in the saved config
   *
   * @generated from field: bool enabled = 10;
   */
  enabled: boolean;

  /**
   * that login's order plant is READY
   *
   * @generated from field: bool connected = 11;
   */
  connected: boolean;

  /**
   * that login's "Allow trading" switch (ADR-0027), as last read
   *
   * @generated from field: bool trading_enabled = 12;
   */
  tradingEnabled: boolean;

  /**
   * display: "1×", "0.5×", "3 fixed"
   *
   * @generated from field: string size = 13;
   */
  size: string;

  /**
   * display: "NQ→MNQ ×10, ES→MES ×10"
   *
   * @generated from field: string symbol_map = 14;
   */
  symbolMap: string;

  /**
   * non-empty while the follower is paused (reject / risk); cleared by Resume
   *
   * @generated from field: string paused_reason = 15;
   */
  pausedReason: string;

  /**
   * ADR-0046 (owner decision 2026-10-03): what the follower holds that copy manages, as the group
   * switch / guarded edit check counts it — "unknown: …" (login down or kicked, positions not
   * confirmed), its positions and working orders; empty when it is known flat.
   *
   * @generated from field: string exposure = 16;
   */
  exposure: string;
};

/**
 * Describes the message helm.v1.CopyFollowerState.
 * Use `create(CopyFollowerStateSchema)` to create a new message.
 */
export const CopyFollowerStateSchema: GenMessage<CopyFollowerState> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 2);

/**
 * @generated from message helm.v1.CopyState
 */
export type CopyState = Message<"helm.v1.CopyState"> & {
  /**
   * the active copy group's id (ADR-0046); empty: no group active, nothing copied
   *
   * @generated from field: string group_id = 1;
   */
  groupId: string;

  /**
   * the active group's name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * @generated from field: bool paused = 4;
   */
  paused: boolean;

  /**
   * @generated from field: string leader_account_id = 5;
   */
  leaderAccountId: string;

  /**
   * @generated from field: string leader_strategy_instance_id = 6;
   */
  leaderStrategyInstanceId: string;

  /**
   * MIRROR_ORDERS | MIRROR_FILLS
   *
   * @generated from field: string copy_mode = 7;
   */
  copyMode: string;

  /**
   * @generated from field: repeated helm.v1.CopyFollowerState followers = 8;
   */
  followers: CopyFollowerState[];

  /**
   * stored login of the leader account (empty: the env dev login)
   *
   * @generated from field: string leader_login_id = 9;
   */
  leaderLoginId: string;

  /**
   * copy_config.version this state reflects
   *
   * @generated from field: int64 config_version = 10;
   */
  configVersion: bigint;

  /**
   * non-empty: the stored config is invalid and nothing is copied
   *
   * @generated from field: string config_error = 11;
   */
  configError: string;

  /**
   * @generated from field: bool flatten_on_leader_flat = 12;
   */
  flattenOnLeaderFlat: boolean;

  /**
   * @generated from field: bool copy_brackets = 13;
   */
  copyBrackets: boolean;

  /**
   * the leader login's order plant is READY
   *
   * @generated from field: bool leader_connected = 14;
   */
  leaderConnected: boolean;

  /**
   * ADR-0046: positions / orders left as independent at a group switch, which copy no longer
   * manages (no copy, flatten or cancel acts on them until they are flat), one display line each.
   *
   * @generated from field: repeated string released = 15;
   */
  released: string[];

  /**
   * ADR-0046 (owner decision 2026-10-03): the leader's own positions, which never block a switch
   * or an edit and are not managed by copy — a warning line, empty when the leader is known flat.
   *
   * @generated from field: string leader_note = 16;
   */
  leaderNote: string;

  /**
   * ADR-0046 (owner decision 2026-10-03 evening): followers of the active group switched Off while
   * they still hold or work something — one warning line each: it is the owner's to manage now
   * (no new copies, no leader-flat flatten). Empty when no Off follower holds anything.
   *
   * @generated from field: repeated string off_notes = 17;
   */
  offNotes: string[];

  /**
   * ADR-0052 (owner decision 2026-10-04): every active copy group — ON (`enabled`) or paused
   * (`enabled` false, `config_error` empty) — each as its own CopyState (its `groups` is empty;
   * `released` is only on the top level). The top-level fields above describe the primary group
   * (the first ON, else the first active) for pages that know one group. Empty: no group active.
   *
   * @generated from field: repeated helm.v1.CopyState groups = 18;
   */
  groups: CopyState[];
};

/**
 * Describes the message helm.v1.CopyState.
 * Use `create(CopyStateSchema)` to create a new message.
 */
export const CopyStateSchema: GenMessage<CopyState> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 3);

/**
 * One line of the copy log (SPEC §11.8). Ordered, replayable; also kept in copy_log (Postgres).
 *
 * @generated from message helm.v1.CopyLogEntry
 */
export type CopyLogEntry = Message<"helm.v1.CopyLogEntry"> & {
  /**
   * @generated from field: fixed64 ts_ns = 1;
   */
  tsNs: bigint;

  /**
   * @generated from field: helm.v1.NoticeLevel level = 2;
   */
  level: NoticeLevel;

  /**
   * COPY_PLACED | COPY_SKIPPED | COPY_REJECTED | COPY_MODIFIED | COPY_CANCELLED | COPY_FLATTEN | COPY_SYNC | COPY_OFF | …
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: string follower_login_id = 5;
   */
  followerLoginId: string;

  /**
   * @generated from field: string follower_account = 6;
   */
  followerAccount: string;

  /**
   * @generated from field: string leader_order_id = 7;
   */
  leaderOrderId: string;

  /**
   * @generated from field: string follower_order_id = 8;
   */
  followerOrderId: string;
};

/**
 * Describes the message helm.v1.CopyLogEntry.
 * Use `create(CopyLogEntrySchema)` to create a new message.
 */
export const CopyLogEntrySchema: GenMessage<CopyLogEntry> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 4);

/**
 * Client → gateway copy-trader actions (trading socket). Configuration changes go through the
 * API (audited; a typed confirmation turns the master switch on) — except an edit that takes
 * followers away from the active group (`save*`), which the gateway checks; these are the
 * runtime actions.
 *
 * @generated from message helm.v1.CopyCommand
 */
export type CopyCommand = Message<"helm.v1.CopyCommand"> & {
  /**
   * query | off | sync_now | resume | flatten_followers | reconnect | activate | activate_flatten | activate_leave | save | save_flatten | save_leave
   *
   * @generated from field: string action = 1;
   */
  action: string;

  /**
   * resume / sync_now / flatten_followers: one follower (empty = all)
   *
   * @generated from field: string follower_login_id = 2;
   */
  followerLoginId: string;

  /**
   * @generated from field: string follower_account = 3;
   */
  followerAccount: string;

  /**
   * activate*: the copy group to make active (ADR-0046; empty = no group). `activate` is refused
   * while the active group has copied exposure; `activate_flatten` flattens its followers first;
   * `activate_leave` leaves what they hold as independent positions. A switch turns copying OFF.
   *
   * @generated from field: string group_id = 4;
   */
  groupId: string;

  /**
   * save*: an edit of the active group that removes followers or changes its leader (ADR-0046,
   * owner decision 2026-10-03) — the whole setup as `PUT /v1/copy` takes it (JSON with `groups`)
   * and the copy_config version it was edited from. `save` is refused while the removed followers
   * hold copied exposure; `save_flatten` flattens them first; `save_leave` leaves what they hold
   * as independent positions. The gateway keeps the active group and the master switch.
   *
   * @generated from field: string setup_json = 5;
   */
  setupJson: string;

  /**
   * @generated from field: int64 expected_version = 6;
   */
  expectedVersion: bigint;
};

/**
 * Describes the message helm.v1.CopyCommand.
 * Use `create(CopyCommandSchema)` to create a new message.
 */
export const CopyCommandSchema: GenMessage<CopyCommand> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 5);

/**
 * @generated from message helm.v1.AlertFired
 */
export type AlertFired = Message<"helm.v1.AlertFired"> & {
  /**
   * @generated from field: string alert_id = 1;
   */
  alertId: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: string symbol = 3;
   */
  symbol: string;

  /**
   * @generated from field: sint64 price_ticks = 4;
   */
  priceTicks: bigint;

  /**
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message helm.v1.AlertFired.
 * Use `create(AlertFiredSchema)` to create a new message.
 */
export const AlertFiredSchema: GenMessage<AlertFired> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 6);

/**
 * @generated from message helm.v1.StrategyState
 */
export type StrategyState = Message<"helm.v1.StrategyState"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: string strategy_name = 2;
   */
  strategyName: string;

  /**
   * @generated from field: string version_sha = 3;
   */
  versionSha: string;

  /**
   * @generated from field: string account_id = 4;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 5;
   */
  symbol: string;

  /**
   * DISABLED | STARTING | WARMING | WAITING_FLAT | RUNNING | PAUSED | STOPPING | STOPPED | FAULTED
   *
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * @generated from field: string state_reason = 7;
   */
  stateReason: string;

  /**
   * @generated from field: sint32 position_qty = 8;
   */
  positionQty: number;

  /**
   * @generated from field: sint64 today_pnl_cents = 9;
   */
  todayPnlCents: bigint;

  /**
   * @generated from field: uint32 trades_today = 10;
   */
  tradesToday: number;

  /**
   * @generated from field: string last_signal = 11;
   */
  lastSignal: string;

  /**
   * @generated from field: string drift_status = 12;
   */
  driftStatus: string;
};

/**
 * Describes the message helm.v1.StrategyState.
 * Use `create(StrategyStateSchema)` to create a new message.
 */
export const StrategyStateSchema: GenMessage<StrategyState> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 7);

/**
 * @generated from message helm.v1.StrategyLog
 */
export type StrategyLog = Message<"helm.v1.StrategyLog"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: string level = 3;
   */
  level: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message helm.v1.StrategyLog.
 * Use `create(StrategyLogSchema)` to create a new message.
 */
export const StrategyLogSchema: GenMessage<StrategyLog> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 8);

/**
 * @generated from message helm.v1.StrategyPlot
 */
export type StrategyPlot = Message<"helm.v1.StrategyPlot"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "price" | "new" | pane id
   *
   * @generated from field: string panel = 3;
   */
  panel: string;

  /**
   * @generated from field: fixed64 bar_open_ns = 4;
   */
  barOpenNs: bigint;

  /**
   * @generated from field: double value = 5;
   */
  value: number;

  /**
   * @generated from field: string color = 6;
   */
  color: string;
};

/**
 * Describes the message helm.v1.StrategyPlot.
 * Use `create(StrategyPlotSchema)` to create a new message.
 */
export const StrategyPlotSchema: GenMessage<StrategyPlot> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 9);

/**
 * @generated from message helm.v1.StrategyCommand
 */
export type StrategyCommand = Message<"helm.v1.StrategyCommand"> & {
  /**
   * empty + KILL_ALL = global kill switch
   *
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * START | PAUSE | RESUME | STOP | FLATTEN | KILL_ALL
   *
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * KILL_ALL option (SPEC §11A.10 step 4), default off
   *
   * @generated from field: bool flatten_positions = 3;
   */
  flattenPositions: boolean;
};

/**
 * Describes the message helm.v1.StrategyCommand.
 * Use `create(StrategyCommandSchema)` to create a new message.
 */
export const StrategyCommandSchema: GenMessage<StrategyCommand> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 10);

/**
 * @generated from message helm.v1.IndicatorSubscribe
 */
export type IndicatorSubscribe = Message<"helm.v1.IndicatorSubscribe"> & {
  /**
   * @generated from field: string sub_id = 1;
   */
  subId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * serialised BarSpec key
   *
   * @generated from field: string bar_spec = 3;
   */
  barSpec: string;

  /**
   * @generated from field: string indicator_id = 4;
   */
  indicatorId: string;

  /**
   * @generated from field: string version_sha = 5;
   */
  versionSha: string;

  /**
   * @generated from field: string params_json = 6;
   */
  paramsJson: string;
};

/**
 * Describes the message helm.v1.IndicatorSubscribe.
 * Use `create(IndicatorSubscribeSchema)` to create a new message.
 */
export const IndicatorSubscribeSchema: GenMessage<IndicatorSubscribe> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 11);

/**
 * @generated from message helm.v1.IndicatorValues
 */
export type IndicatorValues = Message<"helm.v1.IndicatorValues"> & {
  /**
   * @generated from field: string sub_id = 1;
   */
  subId: string;

  /**
   * @generated from field: fixed64 bar_open_ns = 2;
   */
  barOpenNs: bigint;

  /**
   * @generated from field: repeated string plot_names = 3;
   */
  plotNames: string[];

  /**
   * @generated from field: repeated double values = 4 [packed = true];
   */
  values: number[];

  /**
   * forming-bar value in update="tick" mode
   *
   * @generated from field: bool provisional = 5;
   */
  provisional: boolean;
};

/**
 * Describes the message helm.v1.IndicatorValues.
 * Use `create(IndicatorValuesSchema)` to create a new message.
 */
export const IndicatorValuesSchema: GenMessage<IndicatorValues> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 12);

/**
 * Existing personal lockout operation, scoped to the currently installed primary orders actor.
 * Token comes from SessionState; stale actor/restart requests are refused, never replayed.
 *
 * @generated from message helm.v1.ManualLockout
 */
export type ManualLockout = Message<"helm.v1.ManualLockout"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * @generated from field: string actor_token = 3;
   */
  actorToken: string;

  /**
   * rest_of_session | hours | until_next_session | until
   *
   * @generated from field: string preset = 4;
   */
  preset: string;

  /**
   * @generated from field: uint32 hours = 5;
   */
  hours: number;

  /**
   * @generated from field: fixed64 until_ms = 6;
   */
  untilMs: bigint;

  /**
   * @generated from field: bool flatten = 7;
   */
  flatten: boolean;
};

/**
 * Describes the message helm.v1.ManualLockout.
 * Use `create(ManualLockoutSchema)` to create a new message.
 */
export const ManualLockoutSchema: GenMessage<ManualLockout> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 13);

/**
 * Applying the lock, requesting flatten and persisting are separate outcomes.
 *
 * @generated from message helm.v1.ManualLockoutResult
 */
export type ManualLockoutResult = Message<"helm.v1.ManualLockoutResult"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * @generated from field: bool applied = 3;
   */
  applied: boolean;

  /**
   * @generated from field: fixed64 until_ms = 4;
   */
  untilMs: bigint;

  /**
   * not_requested | requested | failed | unknown (batch receipt missing)
   *
   * @generated from field: string flatten_status = 5;
   */
  flattenStatus: string;

  /**
   * pending | volatile | not_applied | unknown (batch receipt missing)
   *
   * @generated from field: string persistence = 6;
   */
  persistence: string;

  /**
   * @generated from field: string code = 7;
   */
  code: string;

  /**
   * @generated from field: string message = 8;
   */
  message: string;
};

/**
 * Describes the message helm.v1.ManualLockoutResult.
 * Use `create(ManualLockoutResultSchema)` to create a new message.
 */
export const ManualLockoutResultSchema: GenMessage<ManualLockoutResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 14);

/**
 * Current connected account inventory only; never logs in a disconnected account.
 *
 * @generated from message helm.v1.ManualLockoutInventoryRequest
 */
export type ManualLockoutInventoryRequest = Message<"helm.v1.ManualLockoutInventoryRequest"> & {
};

/**
 * Describes the message helm.v1.ManualLockoutInventoryRequest.
 * Use `create(ManualLockoutInventoryRequestSchema)` to create a new message.
 */
export const ManualLockoutInventoryRequestSchema: GenMessage<ManualLockoutInventoryRequest> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 15);

/**
 * @generated from message helm.v1.ManualLockoutTarget
 */
export type ManualLockoutTarget = Message<"helm.v1.ManualLockoutTarget"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string actor_token = 3;
   */
  actorToken: string;
};

/**
 * Describes the message helm.v1.ManualLockoutTarget.
 * Use `create(ManualLockoutTargetSchema)` to create a new message.
 */
export const ManualLockoutTargetSchema: GenMessage<ManualLockoutTarget> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 16);

/**
 * @generated from message helm.v1.ManualLockoutUnavailable
 */
export type ManualLockoutUnavailable = Message<"helm.v1.ManualLockoutUnavailable"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message helm.v1.ManualLockoutUnavailable.
 * Use `create(ManualLockoutUnavailableSchema)` to create a new message.
 */
export const ManualLockoutUnavailableSchema: GenMessage<ManualLockoutUnavailable> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 17);

/**
 * @generated from message helm.v1.ManualLockoutInventoryResult
 */
export type ManualLockoutInventoryResult = Message<"helm.v1.ManualLockoutInventoryResult"> & {
  /**
   * session-instance token; changes on gateway/session restart
   *
   * @generated from field: string scope_token = 1;
   */
  scopeToken: string;

  /**
   * @generated from field: repeated helm.v1.ManualLockoutTarget targets = 2;
   */
  targets: ManualLockoutTarget[];

  /**
   * @generated from field: repeated helm.v1.ManualLockoutUnavailable unavailable = 3;
   */
  unavailable: ManualLockoutUnavailable[];

  /**
   * every currently owned actor supplied a current READY account list
   *
   * @generated from field: bool complete = 4;
   */
  complete: boolean;
};

/**
 * Describes the message helm.v1.ManualLockoutInventoryResult.
 * Use `create(ManualLockoutInventoryResultSchema)` to create a new message.
 */
export const ManualLockoutInventoryResultSchema: GenMessage<ManualLockoutInventoryResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 18);

/**
 * @generated from message helm.v1.ManualLockoutBatch
 */
export type ManualLockoutBatch = Message<"helm.v1.ManualLockoutBatch"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string scope_token = 2;
   */
  scopeToken: string;

  /**
   * exact user-confirmed inventory, never "all" account ID
   *
   * @generated from field: repeated helm.v1.ManualLockoutTarget targets = 3;
   */
  targets: ManualLockoutTarget[];

  /**
   * revalidate full connected inventory before starting; otherwise exactly one target
   *
   * @generated from field: bool all_accounts = 4;
   */
  allAccounts: boolean;

  /**
   * @generated from field: string preset = 5;
   */
  preset: string;

  /**
   * @generated from field: uint32 hours = 6;
   */
  hours: number;

  /**
   * @generated from field: fixed64 until_ms = 7;
   */
  untilMs: bigint;

  /**
   * @generated from field: bool flatten = 8;
   */
  flatten: boolean;
};

/**
 * Describes the message helm.v1.ManualLockoutBatch.
 * Use `create(ManualLockoutBatchSchema)` to create a new message.
 */
export const ManualLockoutBatchSchema: GenMessage<ManualLockoutBatch> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 19);

/**
 * @generated from message helm.v1.ManualLockoutAccountResult
 */
export type ManualLockoutAccountResult = Message<"helm.v1.ManualLockoutAccountResult"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: helm.v1.ManualLockoutResult result = 2;
   */
  result?: ManualLockoutResult | undefined;
};

/**
 * Describes the message helm.v1.ManualLockoutAccountResult.
 * Use `create(ManualLockoutAccountResultSchema)` to create a new message.
 */
export const ManualLockoutAccountResultSchema: GenMessage<ManualLockoutAccountResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 20);

/**
 * @generated from message helm.v1.ManualLockoutBatchResult
 */
export type ManualLockoutBatchResult = Message<"helm.v1.ManualLockoutBatchResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: repeated helm.v1.ManualLockoutAccountResult results = 2;
   */
  results: ManualLockoutAccountResult[];

  /**
   * COMPLETED | PARTIAL_SCOPE_CHANGED | BATCH_IN_PROGRESS | refusal; inspect each outcome
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: repeated helm.v1.ManualLockoutUnavailable unavailable = 5;
   */
  unavailable: ManualLockoutUnavailable[];
};

/**
 * Describes the message helm.v1.ManualLockoutBatchResult.
 * Use `create(ManualLockoutBatchResultSchema)` to create a new message.
 */
export const ManualLockoutBatchResultSchema: GenMessage<ManualLockoutBatchResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_risk, 21);

